// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggleAttrsBlk[data-v-35305be4]{top:calc(100% - 5px);left:0}", ""]);
// Exports
module.exports = exports;
